import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class StateService {
    filterState = new Map<string, any>();
    signInTypeState: string;

    constructor() {
        this.signInTypeState = sessionStorage.getItem('signInType');
    }

    public updateFilter(name: string, filter: any) {
        this.filterState.set(name, filter);
    }

    public setSignInType(signIntype: string) {
        this.signInTypeState = signIntype;
        if (signIntype) {
            sessionStorage.setItem('signInType', signIntype);
        } else {
            sessionStorage.removeItem('signInType');
        }
    }

    public getFilter(name: string) {
        return this.filterState.get(name);
    }

    public getSignInType() {
        return this.signInTypeState || sessionStorage.getItem('signInType');
    }

    public clearFilters() {
        this.filterState.clear();
    }

    public clearFilter(name: string) {
        this.filterState.delete(name);
    }
}
